var map = {
	"./chapelhill-logo.png": "ed52",
	"./chatham-logo.png": "466c",
	"./cms-logo.png": "5521",
	"./durham-logo.png": "a22f",
	"./foodforstudents-logo.png": "2068",
	"./johnston-logo.png": "4c1b",
	"./mff-logo.png": "cb0c",
	"./roanoke-logo.png": "5891",
	"./wake-logo.png": "f7d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1cd3";